import React, { useState } from "react";
import PropTypes from 'prop-types';
import "./form.css";
import { useForm, ValidationError } from "@formspree/react";

function ContactForm() {
  const [state, handleSubmit] = useForm("xwkddyld");
  const [emailError, setEmailError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === "email") {
      if (value && !validateEmail(value)) {
        setEmailError("Please enter a valid email address");
      } else {
        setEmailError("");
      }
    }
  };

  const isFormValid = () => {
    return (
      formData.name.trim() !== "" &&
      formData.email.trim() !== "" &&
      validateEmail(formData.email) &&
      formData.message.trim() !== "" &&
      !emailError
    );
  };

  const handleFormSubmit = (e) => {
    const email = e.target.email.value;
    if (!validateEmail(email)) {
      e.preventDefault();
      setEmailError("Please enter a valid email address");
      return;
    }
    handleSubmit(e);
  };

  if (state.succeeded) {
    return (
      <div className="form-success">
        <h3>Thanks! I'll get back to you soon.</h3>
      </div>
    );
  }

  return (
    <form onSubmit={handleFormSubmit} className="contact-form">
      <div className="form-group">
        <label htmlFor="name">Name</label>
        <input
          id="name"
          type="text"
          name="name"
          required
          aria-label="Name"
          placeholder="Enter your name..."
          value={formData.name}
          onChange={handleInputChange}
        />
        <ValidationError prefix="Name" field="name" errors={state.errors} />
      </div>

      <div className="form-group">
        <label htmlFor="email">Email Address</label>
        <input
          id="email"
          type="email"
          name="email"
          required
          aria-label="Email Address"
          placeholder="your.email@example.com"
          value={formData.email}
          onChange={handleInputChange}
        />
        {emailError && <span className="error-message">{emailError}</span>}
        <ValidationError prefix="Email" field="email" errors={state.errors} />
      </div>

      <div className="form-group">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          required
          aria-label="Message"
          placeholder="Type your message here..."
          value={formData.message}
          onChange={handleInputChange}
        />
        <ValidationError prefix="Message" field="message" errors={state.errors} />
      </div>

      <button
        type="submit"
        disabled={state.submitting || !isFormValid()}
        className={state.submitting ? 'submitting' : ''}
      >
        {state.submitting ? 'Sending...' : 'Submit'}
      </button>
    </form>
  );
}

export default ContactForm;
